import { FunctionComponent, useContext, useEffect, useState } from "react";
import styles from "./PastNotification.module.css";
import {NotificationDataType, getFormattedDate, notificationData} from '../../../../helper';
import {useNavigate} from 'react-router-dom'
import moment from "moment";
import 'moment-timezone';
import images from "../../../../assets/images";
import { globalContext } from "../../../../Provider/AppProvider";
import { GET_NOTIFICATIONS, UPDATE_READ_STATUS } from "../api/NotificationQuery";
import { useLazyQuery, useMutation } from "@apollo/client";

const PastNotification: FunctionComponent<NotificationDataType> = ({notificationData,handleClose}) => {
  const navigate = useNavigate();
  const [timeAgoList, setTimeAgoList] = useState<string[]>([]);
  const {DefaultProfile} = images;
  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const date = getFormattedDate(new Date());

  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      tempData.notification.reSettingNotificationCount = !globalState.notification.reSettingNotificationCount
      handleGlobalState(tempData)
    }
  })

  const [updateReadStatus] = useMutation(UPDATE_READ_STATUS, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      getWebNotification({
        variables: {
          todayDate: date,
          userId: globalState?.profile?.id
        },
      });
    },
  });


  

  const handleClick = (recentNotification:notificationData) =>{
    const tempStateForPast = {...globalState};
    tempStateForPast.notification.text = recentNotification?.type==="DeleteUser"?`${recentNotification?.title.slice(0, recentNotification?.title.indexOf("account"))} [deleted user]`:recentNotification?.title.slice(0, recentNotification?.title.indexOf("requested"));
    tempStateForPast.notification.notificationClicked = true;
    tempStateForPast.notification.ticketId = recentNotification?.ticket?.t_id ?? null;
    tempStateForPast.notification.tpId = recentNotification?.ticket_placement?.tp_id ?? null;
    tempStateForPast.notification.tp_id_array=recentNotification?.tp_id_array??null;
    tempStateForPast.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel;
    handleGlobalState(tempStateForPast);
    navigate("/tickets");
    updateReadStatus({
      variables:{
        feedId:recentNotification?.f_id
      }
    })
    handleClose();
  }

  useEffect(() => {
    const calculateTimeAgo = () => {
      const currentDate = moment().startOf('day'); 
  
      const timeAgoArray = notificationData?.map((notification: notificationData) => {
        const notificationDate = moment(notification.notification).startOf('day'); 
        const diffDays = currentDate.diff(notificationDate, 'days');
        
        if (diffDays === 1) {
          return `1 day ago`;
        } else {
          return `${diffDays} days ago`;
        }
      });
  
      setTimeAgoList(timeAgoArray as string[]);
    };
  
    calculateTimeAgo();
    return () => {
      setTimeAgoList([]);
    };
  }, [notificationData]);
  
  return (
    <div className={styles.pastNotification}>
      <div className={styles.past}>
        <b className={styles.past1}>Past</b>
      </div>
      <div className={styles.notificationCards}>
        {
          notificationData?.map((notification: notificationData,index:number)=>(
            <div key={notification.f_id} className={styles.notification} onClick={()=> handleClick(notification)}>
            <div className={styles.container}>
              <div className={styles.all}>
                <div className={styles.img}>
                  <img className={styles.imgIcon} alt="userprofile" src={notification?.ticket?.event?.eventImage? notification?.ticket?.event?.eventImage:DefaultProfile } />
                </div>
                <div className={styles.content}>
                  <div className={styles.text}>
                  <b className={notification?.type==="DeleteUser"?styles.deleteUser:styles.mainTitle}>
                  {notification?.title ?? ""}
                    </b>
                  </div>
                  <div className={styles.subText}>
                    <div className={styles.subTitle}>
                     {`${notification?.ticket?.event?.eventName ?? ""} ${notification?.ticket?.event?.eventDate?moment(notification?.ticket?.event?.eventDate).tz('America/Chicago').format('ddd DD MMM, hh:mm A z'):""}`}
                    </div>
                    <div className={styles.text1} />
                    <div className={styles.subTitle}>
                      {notification?.ticket?.event?.eventAddress ?? ""}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.tagTimeStamp}>
                <div className={styles.minsAgo}>{timeAgoList[index]}</div>
              </div>
            </div>
          </div>
          ))
        }
      </div>
    </div>
  );
};

export default PastNotification;
